import type {
  ChangeMichelinHotelFilterAction,
  ChangeMichelinHotelExploreDestinationAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

export const MICHELIN_HOTEL_FILTER_CHANGED = 'MICHELIN_HOTEL_FILTER_CHANGED';

export const MICHELIN_HOTEL_EXPLORE_DESTINATION_CHANGED =
  'MICHELIN_HOTEL_EXPLORE_DESTINATION_CHANGED';

export const michelinHotelFilterChanged = (filterId: string): ChangeMichelinHotelFilterAction => ({
  type: MICHELIN_HOTEL_FILTER_CHANGED,
  payload: {
    filterId,
  },
});

export const michelinHotelExploreDestinationChanged =
  (): ChangeMichelinHotelExploreDestinationAction => ({
    type: MICHELIN_HOTEL_EXPLORE_DESTINATION_CHANGED,
  });
